import { Trans, useLingui } from "@lingui/react/macro"
import * as React from "react"

import UniversalLink from "../../../../design-system/universal-link"
import OptimizedImage from "../../../optimized-image"
import FooterCopyright from "../footer-copyright"
import FooterLink from "../footer-link"
import * as styles from "./index.module.scss"

function FooterBottomSection() {
  const { t } = useLingui()

  return (
    <div className={styles.container}>
      <div className={styles.footerGridBottom}>
        <div className={styles.contentLeft}>
          <FooterCopyright />
          <div className={styles.divider} />
          <div className={styles.termsContainer}>
            <FooterLink to="/terms" text={<Trans>Terms</Trans>} />
            <FooterLink to="/privacy" text={<Trans>Privacy</Trans>} />
          </div>
        </div>
        <div className={styles.contentRight}>
          <UniversalLink
            to="https://www.w3.org/WAI/WCAG2AA-Conformance"
            target="_blank"
          >
            <OptimizedImage
              width={82}
              height={28}
              src="https://www.datocms-assets.com/85985/1697647559-wcag2aa-blue.png"
              alt={t`Level AA conformance, W3C WAI Web Content Accessibility Guidelines 2.0`}
              loading="lazy"
              data-chromatic="ignore"
              preset="graphic"
            />
          </UniversalLink>
          <UniversalLink to="https://www.aicpa.org/soc4so" target="_blank">
            <OptimizedImage
              width={40}
              height={40}
              src="https://www.datocms-assets.com/85985/1698171187-soc2.png"
              alt={t`AIPCA SOC 2`}
              loading="lazy"
              preset="graphic"
            />
          </UniversalLink>
        </div>
      </div>
    </div>
  )
}

export default FooterBottomSection
